import { useTheme } from '@mui/material/styles';
import RequeridoLabel from "../../../commons/labels/RequeridoLabel";
import CircularLoading from "../../../commons/loading/CircularLoading";
import { StyledSiniestralidad } from "../../../styled/Siniestros";

const DialogDescargarReporte = ({ open }) => {
  const theme = useTheme();

  return (
    <StyledSiniestralidad.AdjuntarFormularioDialog
      open={open}
      fullWidth
      maxWidth="md"
    >
      <StyledSiniestralidad.LoadingContainer>
        <CircularLoading style={{ color: `${theme.palette.tertiary.main}` }} />
        <RequeridoLabel text="Descargando el reporte de predenuncia..." />
      </StyledSiniestralidad.LoadingContainer>
    </StyledSiniestralidad.AdjuntarFormularioDialog>
  );
};

export default DialogDescargarReporte;
